function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.4 158.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "apple-pay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M225.4.1H17.6a24.87,24.87,0,0,0-4.7.4A13.49,13.49,0,0,0,8.5,2,12.14,12.14,0,0,0,4.6,4.8,14.59,14.59,0,0,0,1.9,8.6,17.61,17.61,0,0,0,.4,13C.2,14.5.1,16,0,17.6V140.9a24.87,24.87,0,0,0,.4,4.7A13.49,13.49,0,0,0,1.9,150a14,14,0,0,0,6.5,6.5,17.61,17.61,0,0,0,4.4,1.5,24.18,24.18,0,0,0,4.7.4H229.9a24.87,24.87,0,0,0,4.7-.4,13.49,13.49,0,0,0,4.4-1.5,14,14,0,0,0,6.5-6.5,17.61,17.61,0,0,0,1.5-4.4,24.18,24.18,0,0,0,.4-4.7V17.7A24.87,24.87,0,0,0,247,13a13.49,13.49,0,0,0-1.5-4.4A14,14,0,0,0,239,2.1,17.61,17.61,0,0,0,234.6.6a24.18,24.18,0,0,0-4.7-.4h-2.1a19.27,19.27,0,0,0-2.4-.1Z",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M225.4,5.4h4.5a26.62,26.62,0,0,1,3.9.3,9.64,9.64,0,0,1,3,1,8.4,8.4,0,0,1,2.4,1.8,10.77,10.77,0,0,1,1.8,2.4,8.84,8.84,0,0,1,1,3,26.62,26.62,0,0,1,.3,3.9V140.9a26.62,26.62,0,0,1-.3,3.9,9.64,9.64,0,0,1-1,3,10.61,10.61,0,0,1-4.2,4.2,9.05,9.05,0,0,1-2.9,1,27.48,27.48,0,0,1-3.8.3H17.7a27.69,27.69,0,0,1-3.9-.3,9.64,9.64,0,0,1-3-1,8.4,8.4,0,0,1-2.4-1.8,10.77,10.77,0,0,1-1.8-2.4,8.84,8.84,0,0,1-1-3,26.62,26.62,0,0,1-.3-3.9V17.8a26.62,26.62,0,0,1,.3-3.9,9.64,9.64,0,0,1,1-3A8.4,8.4,0,0,1,8.4,8.5a10.77,10.77,0,0,1,2.4-1.8,8.84,8.84,0,0,1,3-1,26.62,26.62,0,0,1,3.9-.3H225.4",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M65.1,53.6a13.37,13.37,0,0,0,3.1-9.7,13.54,13.54,0,0,0-9,4.7c-1.9,2.2-3.7,5.9-3.2,9.4,3.4.2,6.9-1.8,9.1-4.4",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M68.2,58.5c-5-.3-9.3,2.8-11.7,2.8s-6.1-2.7-10-2.6a15,15,0,0,0-12.6,7.6c-5.4,9.3-1.4,23,3.8,30.6,2.5,3.7,5.6,7.9,9.6,7.7,3.8-.1,5.3-2.5,9.9-2.5s6,2.5,10,2.4c4.2-.1,6.8-3.7,9.3-7.5a36.47,36.47,0,0,0,4.2-8.6c-.1-.1-8.1-3.1-8.1-12.3-.1-7.7,6.3-11.4,6.6-11.6-3.5-5.2-9.1-5.8-11-6",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M118.1,48.1c10.9,0,18.5,7.5,18.5,18.4S128.9,85,117.9,85H105.8v19.2H97.1V48.1ZM105.8,77.7h10c7.6,0,11.9-4.1,11.9-11.2s-4.3-11.1-11.9-11.1h-10Z",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M138.7,92.6c0-7.2,5.5-11.3,15.6-11.9l10.8-.7V76.9c0-4.5-3-7-8.3-7-4.4,0-7.6,2.3-8.2,5.7h-7.9c.2-7.3,7.1-12.6,16.3-12.6,10,0,16.4,5.2,16.4,13.3v27.9h-8V97.5h-.2c-2.3,4.4-7.3,7.2-12.8,7.2C144.4,104.6,138.7,99.8,138.7,92.6ZM165.1,89V85.9l-9.7.6c-5.4.3-8.3,2.4-8.3,5.9s3,5.6,7.6,5.6C160.7,98,165.1,94.2,165.1,89Z",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M180.9,119.2v-6.7a19.66,19.66,0,0,0,2.6.2c3.8,0,6-1.6,7.3-5.8l.8-2.5L176.9,63.6H186l10.3,33.1h.2l10.3-33.1h8.9l-15.3,42.9c-3.5,9.8-7.5,13.1-16,13.1A33.86,33.86,0,0,1,180.9,119.2Z",
    transform: "translate(0 -0.1)",
    style: {
      fill: "#231f20"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/apple_pay.ac4df4cb19afa335e97eec98beb41924.svg";
export { ForwardRef as ReactComponent };